import { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../../actions/userActions';
import { withRouter } from 'react-router-dom';

/*
Component to load user state (from the Auth app).
Should be included in all pages, except sign in page.
*/
export class UserData extends Component {
  componentDidMount() {
    const { exceptOn } = this.props;
    if (!exceptOn || !exceptOn.includes(this.props.location.pathname)){
      // Load info on the current user into state
      this.props.userActions.fetchUserData();
    }
  }

  render() {
    // Nothing to do here, right now mixpanel tracking occurs in the reducer
    return null;
  }
}

UserData.propTypes = {
  userActions: PropTypes.object,
  userData: PropTypes.object,
  exceptOn: PropTypes.array,
  location: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    userData: state.userData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userActions: bindActionCreators(userActions, dispatch)
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UserData));
